import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { REPORT_USAGE, VISIBLE, OTHER_PHYSICIAN } from 'src/constants/appConstants';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import ReportUsageSubHeader from 'src/pages/reportUsage/header/ReportUsageSubHeader';
import ProcedureViewContainer from 'src/pages/reportUsage/procedure/view/ProcedureViewContainer';
import {
    getProcedureInfoRequest,
    validateMazorCodeRequest,
    setShowNoUsageToReportOrCancelPopup,
    setShowUnsavedReportUsageChangesPopUp,
    cancelUsageOrderRequest,
    resetReportUsageStates,
    setRetractorUsedOtherField,
    setMazorCaseCoverageValue,
    resetLevelData,
    getDropdownOptionsRequest,
    setProcedureValue,
    setStealthCaseCoverageValue,
    resetStealthCaseCoverage,
    setPhysicianTextData
} from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    getModifiedPhysicianFinderData,
    getModifiedDeformityCorrectionData,
    getModifiedAdditionalProcedureData,
    getModifiedPhysicianFinderDataOnCheckboxSelection,
    getModifiedBiologicsUsedDataOnCheckboxSelection,
    getModifiedRetractorUsedOnCheckboxSelection,
} from 'src/pages/reportUsage/procedure/dataTransformationUtil';
import ReportUsageFooter from 'src/pages/reportUsage/footer/ReportUsageFooter';
import { UsageContainer } from 'src/pages/reportUsage/ReportUsagee.styled.jsx';

import {
    checkIfValidProcedureData,
    createProcedureDraftOrderObject,
    generateUnidInfoRequestObject,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import {
    VALIDATE_MAZOR_CODE_RESPONSE,
    RESET_CANCEL_USAGE_STATES,
    SET_ADVANCE_ENERGY_DATA,
    VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
} from 'src/pages/reportUsage/redux/action/types';
import {
    setProcedureData,
    setReportUsageFormObject,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    COUNTRY_CODE_JAPN,

} from 'src/constants/productConstants';
import {
    getAdditionalTextareaLimit,
    getRoutePathWithParams,
    isIOSiPhoneDevice,
    isMobileView,
    resumeScrolling,
} from 'src/utils/util';
import { TitleComponent } from 'src/pages/reportUsage/utils/reportUsage.styled';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import NoUsageProcedureHeader, {
    MultiViewComponent,
} from './components/header';
import { sizes } from 'src/styles/Media.styled';
import {
    ENABLED,
    MANDATORY,
    NOT_MANDATORY,
    NOT_VISIBLE
} from 'src/constants/appConstants';

import {
    setOrderStatus,
    getOrderSummaryData,
    setOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import SubmissionViewContainer from 'src/pages/reportUsage/submit/view';
import UnidPlanPdfNotAvailable from '../scheduleSurgery/components/surgery/notifications/UnidPlanPdfNotAvailable';
import { unlockOrderFunc } from '../reportUsage/redux/saga/dataServices';
import UnidSurgeryInfo from './components/unidSurgeryInfo';
import { getConfigurations, resetNotes, setPediatricCheck } from 'src/common/redux/actions';
import { useTranslation } from 'react-i18next';
import { getDropdownValues, resetDropdown } from '../scheduleSurgery/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Procedure = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const initialButtonState = () => [
        {
            btnName: t('reportUsage.common.cancel'),
            btnVisibility: true,
            isBtnDisable: false,
            btnType: 'cancel',
        },
        {
            btnName: t('noUsageToReport.submitButton'),
            btnVisibility: true,
            isBtnDisable: true,
            btnType: 'primary',
        },
    ];
    const history = useHistory();
    const charCountLimit = 40;
    const [footerButtonStatuses, setFooterButtonStatuses] = useState(
        initialButtonState()
    );
    useEffectWithErrorLogging(() => {
        dispatch(
            getConfigurations(
                { resourceType: 'visibility', module: REPORT_USAGE },
                REPORT_USAGE
            )
        );
    }, []);
    const [noUsageOrderDetails, setNoUsageOrderDetails] = useState(null);
    const [mazorxChecked, setMazorxChecked] = useState(false);
    const [showBiologisDetails, setshowBiologisDetails] = useState(false);
    const [selectedPhysicianData, setSelectedPhysicianData] = useState({});
    const [physicianInputValue, setPhysicianInputValue] = useState('');
    const [mazorRoboticsCode, setMazorRoboticsCode] = useState('');
    const [mazorCaseCoverageInputValue, setMazorCaseCoverageInputValue] =
        useState('');
    const [selectedMazorCaseCoverage, setSelectedMazorCaseCoverage] =
        useState('');
    const [pdfNotAvailable, setPdfNotAvailable] = useState(false);
    const [unidSurgeryInfo, setUnidSurgeryInfo] = useState({});
    const [advancedEnergyCheck, setAdvancedEnergyCheck] = useState(false);
    const [advanceEnergyProduct, setAdvanceEnergyProduct] = useState([]);
    const [advEnergyCode, setAdvEnergyCode] = useState(false);
    const [procedureInfoData, setProcedureInfoData] = useState({});
    const [reportUsageFormObj, setReportUsageFormObj] = useState({});
    const [textAreaCharLimit, setTextAreaCharLimit] = useState(charCountLimit);
    const [downArrow, setDownArrow] = useState(false);
    const [
        temporaryProcedureDropdownValue,
        settemporarypProcedureDropdownValue,
    ] = useState({});
    const [procedureDropdownValue, setProcedureDropdownValue] = useState({});
    const [isDisabledPediatric, setDisabledPediatric] = useState(false);
    const [isPediatricSurgery, setPediatricSurgery] = useState('');
    const [pediatricDraftValue, setPediatricDraftValue] = useState(false);
    const [stealthAxisChecked, setStealthAxisChecked] = useState(false);
    const [stealthAxisCode, setStealthAxisCode] = useState('');
    const [stealthAxisAutoPilot, setStealthAxisAutoPilot] = useState(null);
    const [stealthAxisLiveAlign, setStealthAxisLiveAlign] = useState(null);
    const [
        stealthAxisCaseCoverageInputValue,
        setStealthAxisCaseCoverageInputValue,
    ] = useState('');
    const [stealthAxisCodeError, setStealthAxisCodeError] = useState('');
    const [
        selectedStealthAxisCaseCoverage,
        setSelectedStealthAxisCaseCoverage,
    ] = useState('');

    const {
        physicianDropdownZGReportUsageVisibility,
        physicianDropdownZGReportUsageMandatory,
        procedureTypeUsageMandatoryRule,
        procedureTypeUsageVisibility,
        procedureDataPhysician,
        pediatricSurgery,
        pediatricSurgeryMandatory,
        loading,
        reportUsageStealthAutoPilotVisibility,
        reportUsageStealthLiveAlignVisibility,
        physicianTextUsageVisibility,
        physicianTextUsageMandatory,
    } = useSelector((state) => state.loginReducer);
    const { physicianFieldText, physicianTextBoxType } = useSelector(
        (state) => ({
            physicianFieldText:
                state.reportUsageRootReducer.physicianFieldText,
            physicianTextBoxType:
                state.reportUsageRootReducer.physicianTextBoxType,
        })
    );

    const setPhysicianFieldText = (value) => {
        dispatch(setPhysicianTextData({ physicianFieldText: value }));
    };

    const setPhysicianTextBoxType = (value) => {
        dispatch(
            setPhysicianTextData({
                physicianTextBoxType: value,
                ...(value === 'unknown' ? { physicianFieldText: '' } : {}),
            })
        );
    };
    const storedUnidSurgeryData = useSelector(
        (state) => state.reportUsageRootReducer.storedUnidSurgeryData
    );
    const procedureDetail = useSelector(
        (state) => state.orderSummaryReducer?.orderBasicDetails?.procedureDetail
    );
    const isFromOrderDetailsModal = useSelector(
        (state) => state.noUsageToReportReducer.isFromOrderDetailsModal
    );
    const userCountryCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const usageDetailsLoading = useSelector(
        (state) => state.reportUsageRootReducer.usageDetailsLoading
    );
    const procedureDataLoading = useSelector(
        (state) => state.reportUsageRootReducer.procedureDataLoading
    );
    const procedureInfoDetails = useSelector(
        (state) => state.reportUsageRootReducer.procedureInfoDetails
    );
    const { validateMazorCodeRes, kitCodeValidationInProgress } = useSelector(
        (state) => state.reportUsageRootReducer
    );

    const proceduresList = useSelector(
        (state) =>
            state.reportUsageRootReducer.dropdownData.procedures &&
            state.reportUsageRootReducer.dropdownData.procedures.procedureList
    );
    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );

    const cancelSurgeryData = useSelector(
        (state) => state.noUsageToReportReducer.cancelSurgeryData
    );
    const cancelReason = useSelector(
        (state) => state.noUsageToReportReducer.cancelReason
    );
    const cancelUsageInProgress = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageInProgress
    );
    const cancelUsageResponse = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageResponse
    );
    const showUnsavedChangesPopup = useSelector(
        (state) => state.reportUsageRootReducer.showUnsavedChangesPopup
    );
    const procedureValue = useSelector(
        (state) => state.reportUsageRootReducer?.procedureValue
    );
    const { physicians } = useSelector((state) => ({
        physicians:
            state.reportUsageRootReducer.dropdownData?.physicians
                ?.physicianList,
    }));

    const advanceEnergyRes = useSelector(
        (state) => state.reportUsageRootReducer.advanceEnergyData
    );

    const usageProcedureData = useSelector(
        (state) =>
            state.reportUsageRootReducer?.usageDetails?.procedure
                ?.additionProcedure
    );
    const showProcedureDropdown = procedureTypeUsageVisibility === VISIBLE;
    const procedureDataPhysicianVisibility =
        physicianDropdownZGReportUsageVisibility === VISIBLE || procedureDataPhysician === VISIBLE;

    const procedureData = useSelector(
        (state) => state.reportUsageRootReducer.procedureData
    );
    const { salesOrg, pediatricCheck, dropdownData } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
        pediatricCheck: state.loginReducer.pediatricCheck,
        dropdownData: state.reportUsageRootReducer?.dropdownData,
    }));


    const retractorUsedOtherFieldValue = useSelector(
        (state) => state.reportUsageRootReducer.retractorUsedOtherFieldData
    );
    const totalLevelsNumber = useSelector(
        (state) => state.reportUsageRootReducer.totalLevelsNumber
    );
    const uivArray = useSelector(
        (state) => state.reportUsageRootReducer.uivArray
    );
    const livArray = useSelector(
        (state) => state.reportUsageRootReducer.livArray
    );
    const isErrorFoundInFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInFirstLevel
    );
    const reportUsageObject = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );
    const isErrorFoundInProcedure = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInProcedure
    );
    const selectedPhysicianDetails =
        physicians?.length > 0 &&
        physicians.filter(
            (phy) =>
                phy.physicianDisplayName ===
                cancelSurgeryData?.physicianDisplayName
        );

    const pediatricMandatoryRule = pediatricSurgeryMandatory === MANDATORY;
    const pediatricSurgeryVisibility =
        procedureTypeUsageVisibility === VISIBLE
            ? pediatricSurgery === VISIBLE
            : false;
    useEffectWithErrorLogging(() => {
        usageDetails?.procedureCode &&
            dispatch(setPediatricCheck(usageDetails?.pediatricSurgery));
        usageDetails?.procedureCode &&
            usageDetails?.pediatricSurgery !== '' &&
            usageDetails?.pediatricSurgery !== undefined &&
            setPediatricDraftValue(true);
    }, [usageDetails?.pediatricSurgery]);
    useEffectWithErrorLogging(() => {
        setPediatricSurgery(pediatricCheck);
    }, [pediatricCheck]);
    useEffectWithErrorLogging(() => {
        if (
            pediatricSurgeryVisibility &&
            reportUsageObject?.procedureCode &&
            dropdownData?.procedures?.defaultYesPediatricProcedures &&
            dropdownData?.procedures?.defaultYesPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageObject?.procedureCode.trim())
        ) {
            !pediatricDraftValue && dispatch(setPediatricCheck(true));
            pediatricDraftValue && setPediatricDraftValue(false);
        } else if (
            pediatricSurgeryVisibility &&
            reportUsageObject?.procedureCode &&
            dropdownData?.procedures?.defaultNoPediatricProcedures &&
            dropdownData?.procedures?.defaultNoPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageObject?.procedureCode.trim())
        ) {
            !pediatricDraftValue && dispatch(setPediatricCheck(false));
            pediatricDraftValue && setPediatricDraftValue(false);
        } else {
            !pediatricDraftValue && dispatch(setPediatricCheck(''));
            setDisabledPediatric(false);
        }
    }, [
        reportUsageObject?.procedureCode,
        dropdownData?.procedures?.defaultYesPediatricProcedures,
        dropdownData?.procedures?.defaultNoPediatricProcedures,
    ]);

    const checkValidUnidData = () => {
        return Object.entries(storedUnidSurgeryData).every((objArr) => {
            if (objArr[0] == 'unidProducts') {
                return (
                    objArr[1][0].productCFN === 'None' && objArr[1][0].isChecked
                );
            } else if (objArr[0] == 'whyAllRodsNotImplanted') {
                let selectedReason = objArr[1].filter((item) => item.isChecked);

                if (selectedReason && selectedReason.length > 0) {
                    if (
                        selectedReason.find((item) => item.id === 2) ||
                        selectedReason.find((item) => item.id === 4)
                    ) {
                        return unidSurgeryInfo.mPXR;
                    } else {
                        return true;
                    }
                }
            } else if (objArr[0] == 'reasonText') {
                return objArr[1].length > 0;
            } else if (objArr[0] == 'mPXR') {
                let selectedReason =
                    unidSurgeryInfo.whyAllRodsNotImplanted?.filter(
                        (item) => item.isChecked
                    );

                if (selectedReason && selectedReason.length > 0) {
                    if (
                        selectedReason.find((item) => item.id === 2) ||
                        selectedReason.find((item) => item.id === 4)
                    ) {
                        return objArr[1];
                    } else {
                        return true;
                    }
                }
            } else if (objArr[0] == 'mainRodCount') {
                return true;
            }
        });
    };
    useEffectWithErrorLogging(() => {
        if (!cancelReason) {
            const fromScreen = localStorage.getItem('pageName');
            history.push(
                fromScreen === 'Orders'
                    ? getRoutePathWithParams('/orders')
                    : getRoutePathWithParams('/')
            );
        }
    }, [cancelReason]);

    useEffectWithErrorLogging(() => {
        resetProcedurePage();
        if (advanceEnergyRes && procedureInfoDetails?.additionalProcedure) {
            let arCh = Object.keys(advanceEnergyRes).filter(
                (it) => advanceEnergyRes[it] === true
            );
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                arCh.length > 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                setAdvancedEnergyCheck(true);
            }
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (advanceEnergyRes && procedureInfoDetails?.additionalProcedure) {
            let arCh = Object.keys(advanceEnergyRes).filter(
                (it) => advanceEnergyRes[it] === true
            );
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                arCh.length > 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                setAdvancedEnergyCheck(true);
            }
        }
    }, [advanceEnergyRes]);

    useEffectWithErrorLogging(() => {
        const params = {
            sstRef: cancelSurgeryData?.myCaseRef,
        };
        params?.sstRef && params?.sstRef.length > 0 && dispatch(
            getDropdownValues({
                dropDownName: 'mazorCaseCoverageEmployees',
                value: params,
            })
        );
    }, [cancelSurgeryData?.myCaseRef]);

    useEffectWithErrorLogging(() => {

        dispatch(getDropdownOptionsRequest('procedures'));
        if (
            !(
                procedureInfoDetails &&
                Object.keys(procedureInfoDetails).length > 0
            )
        ) {
            const data = {
                procedureCode:
                    showProcedureDropdown && usageDetails?.procedureCode
                        ? usageDetails?.procedureCode
                        : showProcedureDropdown && procedureDetail?.procedureCode
                            ? procedureDetail?.procedureCode
                            : '',
                salesOrg: salesOrg,
            };

            !(Object.keys(data?.procedureCode).length > 0) &&
                dispatch(getProcedureInfoRequest('Usage', data, false));
        }
        let body = document.getElementById('body');
        if (isMobileView()) {
            body.style.backgroundColor = '#140f4b';
        }
        return () => {
            body.style.backgroundColor = '';
            resumeScrolling();
            discardChangesBtnClickHandler(true);
        };
    }, []);

    useEffectWithErrorLogging(() => {
        if (
            procedureInfoDetails &&
            Object.keys(procedureInfoDetails).length > 0
        ) {
            setProcedureInfoData({
                ...procedureInfoData,
                ...procedureInfoDetails,
            });
        }
    }, [procedureInfoDetails]);
    useEffectWithErrorLogging(() => {
        let energyProdArr = [];
        if (procedureInfoDetails && procedureInfoDetails.additionalProcedure) {
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                advancedEnergy >= 0 &&
                !additionalProcedure[advancedEnergy].isSelected
            ) {
                let advEnergyProducts = Object.keys(
                    additionalProcedure[advancedEnergy].advancedEnergyProduct
                ).filter((key) => {
                    return (
                        additionalProcedure[advancedEnergy]
                            ?.advancedEnergyProduct[key] === true
                    );
                });
                advEnergyProducts &&
                    advEnergyProducts.map((pr) => {
                        let obj = { description: pr, isSelected: false };
                        energyProdArr.push(obj);
                    });
                setAdvanceEnergyProduct(energyProdArr);
            } else if (
                advancedEnergy >= 0 &&
                additionalProcedure[advancedEnergy].isSelected &&
                advanceEnergyProduct
            ) {
                let advEnergyProducts = Object.keys(
                    additionalProcedure[advancedEnergy].advancedEnergyProduct
                );
                advEnergyProducts &&
                    advEnergyProducts.map((pr) => {
                        let obj = {
                            description: pr,
                            isSelected:
                                additionalProcedure[advancedEnergy]
                                    ?.advancedEnergyProduct[pr],
                        };
                        energyProdArr.push(obj);
                    });
                setAdvanceEnergyProduct(energyProdArr);
            }
            if (
                usageProcedureData?.advancedEnergyProduct &&
                Object.keys(usageProcedureData?.advancedEnergyProduct).length >
                0
            ) {
                energyProdArr = [];
                let advInd = procedureData.additionalProcedure.findIndex(
                    (it) =>
                        it.description ===
                        t(
                            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.advancedEnergy'
                        )
                );
                if (procedureData?.additionalProcedure[advInd].isSelected) {
                    setAdvancedEnergyCheck(true);
                }
                let prArr = Object.keys(
                    procedureData?.additionalProcedure[advInd]
                        .advancedEnergyProduct
                );
                prArr &&
                    advInd >= 0 &&
                    prArr.map((pr) => {
                        let obj = {
                            description: pr,
                            isSelected:
                                procedureData.additionalProcedure[advInd]
                                    .advancedEnergyProduct[pr],
                        };
                        energyProdArr.push(obj);
                    });
                let data =
                    procedureData?.additionalProcedure[advInd]
                        .advancedEnergyProduct;
                dispatch({
                    type: SET_ADVANCE_ENERGY_DATA,
                    payload: data,
                });
                setAdvanceEnergyProduct(energyProdArr);
            }
        }
    }, [procedureInfoDetails]);

    useEffectWithErrorLogging(() => {
        if (
            usageDetails?.status !== 'failed' &&
            usageDetails &&
            Object.keys(usageDetails).length > 0
        ) {
            setNoUsageOrderDetails(usageDetails);
            if (
                usageDetails.physicianId &&
                usageDetails.physicianId !== 'Other Physician' &&
                usageDetails.physicianName
            ) {
                setSelectedPhysicianData({
                    physicianId: usageDetails.physicianId,
                    physicianDisplayName: usageDetails.physicianName,
                });
            } else if (
                // EMEA text-physician flow: only a name is available (no id).
                !usageDetails.physicianId &&
                usageDetails.physicianName &&
                usageDetails.physicianName !== OTHER_PHYSICIAN
            ) {
                setSelectedPhysicianData({
                    physicianId: '',
                    physicianDisplayName: usageDetails.physicianName,
                });
            }
        } else if (
            usageDetails?.status === 'failed' &&
            cancelSurgeryData &&
            Object.keys(cancelSurgeryData).length > 0
        ) {
            setNoUsageOrderDetails({
                ...cancelSurgeryData,
                accountId:
                    cancelSurgeryData.accountId ||
                    cancelSurgeryData.accountNumber,
                hrefId: cancelSurgeryData.hrefId || cancelSurgeryData.HRefId,
            });
            if (
                ((cancelSurgeryData.physicianId &&
                    cancelSurgeryData.physicianId !== 'Other Physician') ||
                    (selectedPhysicianDetails &&
                        selectedPhysicianDetails[0]?.physicianId)) &&
                (cancelSurgeryData.physicianName ||
                    cancelSurgeryData.physicianDisplayName)
            ) {
                setSelectedPhysicianData({
                    physicianId:
                        cancelSurgeryData.physicianId ||
                        (selectedPhysicianDetails &&
                            selectedPhysicianDetails[0]?.physicianId),
                    physicianDisplayName:
                        cancelSurgeryData.physicianName ||
                        cancelSurgeryData.physicianDisplayName,
                });
            }
        }
    }, [usageDetails, physicians]);

    // EMEA text-physician: hydrate the physician text field/radio from usage
    // details once the config is visible. Mirrors useReportUsageDetailsEffect.
    useEffectWithErrorLogging(() => {
        if (physicianTextUsageVisibility !== VISIBLE) return;
        if (!usageDetails?.physicianName) return;
        if (physicianFieldText) return;
        const isOtherPhysician =
            usageDetails.physicianName === OTHER_PHYSICIAN;
        dispatch(
            setPhysicianTextData({
                physicianTextBoxType: isOtherPhysician ? 'unknown' : 'known',
                physicianFieldText: isOtherPhysician
                    ? ''
                    : usageDetails.physicianName,
            })
        );
    }, [usageDetails, physicianTextUsageVisibility]);

    useEffectWithErrorLogging(() => {
        const shouldCheckPhysicianUsage =
            procedureDataPhysician === 'VISIBLE' ||
            physicianDropdownZGReportUsageVisibility === 'VISIBLE';
        const isPhysicianMissing = !selectedPhysicianData?.physicianId;
        const isPhysicianTextMandatoryMissing =
            physicianTextUsageVisibility === VISIBLE &&
            physicianTextUsageMandatory === MANDATORY &&
            physicianTextBoxType !== 'unknown' &&
            !physicianFieldText;

        const isUnidNonUse = cancelReason?.optionId == 'UNID_NON_USE';

        setFooterButtonStatuses(
            footerButtonStatuses.map((x) =>
                x.btnName !== t('userPanel.logoutPopup.cancelButton') &&
                    x.btnVisibility
                    ? {
                        ...x,
                        isBtnDisable:
                            !cancelReason ||
                            !checkIfValidProcedureData(
                                procedureInfoData,
                                isErrorFoundInProcedure,
                                isErrorFoundInFirstLevel,
                                cancelReason,
                                {
                                    autoPilotVisible: reportUsageStealthAutoPilotVisibility === VISIBLE,
                                    liveAlignVisible: reportUsageStealthLiveAlignVisibility === VISIBLE,
                                }
                            ) ||
                            (isUnidNonUse
                                ? false
                                : shouldCheckPhysicianUsage &&
                                isPhysicianMissing) ||
                            (isUnidNonUse ? false : isPhysicianTextMandatoryMissing) ||
                            (isUnidNonUse
                                ? false
                                : showProcedureDropdown &&
                                procedureTypeUsageMandatoryRule === MANDATORY
                                ? !(
                                    procedureDropdownValue?.procedureCode &&
                                    procedureDropdownValue?.procedureCode
                                        .length > 0
                                )
                                : false) ||
                            (isUnidNonUse
                                ? false
                                : pediatricSurgeryVisibility &&
                                pediatricMandatoryRule
                                ? !(
                                    pediatricCheck !== '' &&
                                    pediatricCheck !== undefined
                                )
                                : false) ||
                            (isUnidNonUse
                                ? false
                                : mazorxChecked
                                ? !(
                                    validateMazorCodeRes &&
                                    validateMazorCodeRes.statusCode ===
                                    '10723'
                                )
                                : false) ||
                            !checkValidUnidData(),
                    }
                    : x
            )
        );
    }, [
        procedureInfoData,
        selectedPhysicianData,
        validateMazorCodeRes,
        mazorxChecked,
        storedUnidSurgeryData,
        advanceEnergyRes,
        advancedEnergyCheck,
        advEnergyCode,
        isErrorFoundInProcedure,
        isErrorFoundInFirstLevel,
        pediatricCheck,
        unidSurgeryInfo,
        cancelReason,
        physicianFieldText,
        physicianTextBoxType,
    ]);


    useEffectWithErrorLogging(() => {
        if (procedureInfoData && procedureInfoData.additionalProcedure) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const mazorxIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'MazorX Robot Used'
            );
            if (
                mazorxIdx >= 0 &&
                additionalProcedureData[mazorxIdx] &&
                additionalProcedureData[mazorxIdx].isSelected
            ) {
                setMazorxChecked(true);
                if (additionalProcedureData[mazorxIdx].mazorKitCode) {
                    setMazorRoboticsCode(
                        additionalProcedureData[mazorxIdx].mazorKitCode
                    );
                }
            } else {
                setMazorxChecked(false);
                setMazorRoboticsCode('');
                if (mazorxIdx >= 0) {
                    additionalProcedureData[mazorxIdx].mazorKitCode = '';
                }
                dispatch({ type: VALIDATE_MAZOR_CODE_RESPONSE, payload: null });
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        if (procedureInfoData && procedureInfoData.additionalProcedure) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const stealthAxisIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'Stealth AXiS'
            );
            if (
                stealthAxisIdx >= 0 &&
                additionalProcedureData[stealthAxisIdx] &&
                additionalProcedureData[stealthAxisIdx].isSelected
            ) {
                setStealthAxisChecked(true);
                if (additionalProcedureData[stealthAxisIdx].stealthAxisCode) {
                    setStealthAxisCode(
                        additionalProcedureData[stealthAxisIdx].stealthAxisCode
                    );
                }
                if (
                    typeof additionalProcedureData[stealthAxisIdx]
                        .stealthAxisAutoPilot === 'boolean'
                ) {
                    setStealthAxisAutoPilot(
                        additionalProcedureData[stealthAxisIdx]
                            .stealthAxisAutoPilot
                    );
                } else {
                    setStealthAxisAutoPilot(null);
                }
                if (
                    typeof additionalProcedureData[stealthAxisIdx]
                        .stealthAxisLiveAlign === 'boolean'
                ) {
                    setStealthAxisLiveAlign(
                        additionalProcedureData[stealthAxisIdx]
                            .stealthAxisLiveAlign
                    );
                } else {
                    setStealthAxisLiveAlign(null);
                }
                if (
                    additionalProcedureData[stealthAxisIdx].stealthCaseCoverage
                ) {
                    setStealthAxisCaseCoverageInputValue(
                        additionalProcedureData[stealthAxisIdx]
                            .stealthCaseCoverage
                    );
                }
            } else {
                setStealthAxisChecked(false);
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                setStealthAxisCodeError('');
                if (stealthAxisIdx >= 0) {
                    additionalProcedureData[stealthAxisIdx].stealthAxisCode =
                        '';
                }
                dispatch({ type: VALIDATE_STEALTH_AXIS_CODE_RESPONSE, payload: null });
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);

    useEffectWithErrorLogging(() => {
        if (
            Object.keys(
                createProcedureDraftOrderObject(
                    procedureInfoData,
                    advanceEnergyProduct,
                    retractorUsedOtherFieldValue,
                    uivArray,
                    livArray,
                    totalLevelsNumber
                )
            ).length > 0
        ) {
            const reportUsageObj = createProcedureDraftOrderObject(
                procedureInfoData,
                advanceEnergyProduct,
                retractorUsedOtherFieldValue,
                uivArray,
                livArray,
                totalLevelsNumber
            );

            setReportUsageFormObj({
                ...reportUsageFormObj,
                procedure: reportUsageObj,
            });
        }
    }, [advanceEnergyProduct]);


    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            retractorUsedOtherFieldValue.length > 0 &&
            getAdditionalTextareaLimit(retractorUsedOtherFieldValue) > 0
        ) {
            setTextAreaCharLimit(
                charCountLimit +
                getAdditionalTextareaLimit(retractorUsedOtherFieldValue)
            );
        } else {
            setTextAreaCharLimit(charCountLimit);
        }
    }, [retractorUsedOtherFieldValue]);


    const setProcedureDropdownValueHandler = (value, flag = false) => {
        if (flag && value) {
            setDownArrow(true);
            value && settemporarypProcedureDropdownValue(value);
        } else {
            setDownArrow(false);

            value && setProcedureDropdownValue(value);
        }
    };
    //isProcedureReq or isProcedureReqConfig is true for US user as per sim-1021
    useEffectWithErrorLogging(() => {
        if (
            (usageDetails?.isProcedureReq ||
                usageDetails?.isProcedureReqConfig) &&
            usageDetails?.procedureCode &&
            usageDetails?.procedureDescription
        ) {
            setReportUsageFormObj((prev) => ({
                ...prev,
                procedureCode: usageDetails?.procedureCode,
            }));
        }
    }, [usageDetails?.procedureCode]);

    useEffectWithErrorLogging(() => {
        if (
            pediatricSurgeryVisibility &&
            pediatricCheck !== '' &&
            pediatricCheck !== undefined
        ) {
            setReportUsageFormObj((prev) => ({
                ...prev,
                pediatricSurgery: pediatricCheck,
            }));
        }
    }, [pediatricCheck]);

    useEffectWithErrorLogging(() => {
        if (
            procedureDropdownValue?.procedureCode !==
            reportUsageObject?.procedureCode &&
            procedureDropdownValue?.procedureCode
        ) {
            setReportUsageFormObj({
                ...reportUsageFormObj,
                procedureCode: procedureDropdownValue?.procedureCode,
            });
        }
    }, [procedureDropdownValue]);
    useEffectWithErrorLogging(() => {
        if (
            procedureValue?.procedureCode?.length > 0

        ) {
            setProcedureDropdownValue(procedureValue);
        }
    }, []);
    useEffectWithErrorLogging(() => {
        if (
            procedureDropdownValue?.procedureCode !==
            reportUsageObject?.procedureCode &&
            !downArrow &&
            procedureDropdownValue?.procedureCode?.length > 0
        ) {
            resetProcedurePage();
            const data = {
                procedureCode: showProcedureDropdown && procedureDropdownValue?.procedureCode
                    ? procedureDropdownValue?.procedureCode
                    : '',
                salesOrg: salesOrg,
            };
            dispatch(setProcedureValue({
                procedureCode: procedureDropdownValue?.procedureCode
                ,
                procedureDescription:
                    procedureDropdownValue?.procedureDescription
            }));
            Object.keys(procedureDropdownValue).length > 0 &&
                dispatch(
                    getProcedureInfoRequest(
                        'Usage',
                        data
                    )
                );
            setDownArrow(false);
        }
    }, [procedureDropdownValue]);
    useEffectWithErrorLogging(() => {
        const value = {
            procedureCode: usageDetails?.procedureCode,
            procedureDescription: usageDetails?.procedureDescription,

        };
        usageDetails?.procedureCode && setProcedureDropdownValue(value);
    }, [usageDetails?.procedureCode]);

    const resetProcedurePage = () => {
        setshowBiologisDetails(false);
        dispatch(resetLevelData());
        setProcedureInfoData({});
        dispatch({
            type: SET_ADVANCE_ENERGY_DATA,
            payload: {},
        });
        dispatch(resetStealthCaseCoverage(''));
        setSelectedMazorCaseCoverage('');
        setMazorCaseCoverageInputValue('');
        setSelectedStealthAxisCaseCoverage('');
        setStealthAxisCaseCoverageInputValue('');
        setAdvancedEnergyCheck(false);
    };

    const radioButtonChangeHandler = (additionalProcedureData, idx, val) => {
        let modifiedData = [];
        if (
            Object.keys(additionalProcedureData).length > 0 &&
            additionalProcedureData !== 'deformityData'
        ) {
            modifiedData = [...additionalProcedureData];
            modifiedData[idx].isSelected = val;
            if (modifiedData[idx].description === 'Advanced Energy') {
                setAdvancedEnergyCheck(val);
                modifiedData[idx].advancedEnergyProduct &&
                    Object.keys(
                        modifiedData[idx].advancedEnergyProduct
                    ).map((key) => {
                        modifiedData[idx].advancedEnergyProduct[
                            key
                        ] = false;
                    });
            }
            if (
                modifiedData[idx].description === 'MazorX Robot Used' &&
                !val
            ) {
                dispatch(setMazorCaseCoverageValue(null));
                setMazorCaseCoverageInputValue('');
                setSelectedMazorCaseCoverage('');
                const mazorIdx = modifiedData.findIndex(
                    (x) => x.description === 'MazorX Robot Used' && !val
                );
                const addProcData = [...modifiedData];
                if (mazorIdx >= 0) {
                    addProcData[mazorIdx].mazorCaseCoverage = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }
            if (modifiedData[idx].description === 'Stealth AXiS' && !val) {
                dispatch(setStealthCaseCoverageValue(null));
                setStealthAxisCaseCoverageInputValue('');
                setSelectedStealthAxisCaseCoverage('');
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                setStealthAxisCodeError('');
                const mazorIdx = modifiedData.findIndex(
                    (x) => x.description === 'Stealth AXiS' && !val
                );
                const addProcData = [...modifiedData];
                if (mazorIdx >= 0) {
                    addProcData[mazorIdx].stealthCaseCoverage = null;
                    addProcData[mazorIdx].stealthAxisCode = '';
                    addProcData[mazorIdx].stealthAxisAutoPilot = null;
                    addProcData[mazorIdx].stealthAxisLiveAlign = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }
            if (
                modifiedData[idx].isSelected === false &&
                modifiedData[idx].description ===
                t(
                    'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.advancedEnergy'
                )
            ) {
                advanceEnergyProduct &&
                    advanceEnergyProduct.map((item) => {
                        item.isSelected = false;
                    });
            }

            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: modifiedData,
            }));
            const modifiedPhysicianFinderData =
                getModifiedPhysicianFinderData(
                    procedureInfoData,
                    val,
                    modifiedData,
                    idx
                );
            if (modifiedPhysicianFinderData) {
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    therapies: modifiedPhysicianFinderData,
                }));
            }
        } else if (additionalProcedureData === 'deformityData') {
            modifiedData = getModifiedDeformityCorrectionData(
                procedureInfoData,
                idx,
                val
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                technologies: modifiedData,
            }));
        }
    };

    const mazorCodeValidator = (e) => {
        const inputValue = e.target.value;
        const res = inputValue.replace(/[^A-Za-z0-9!@#$%^&*()]/g, '').slice(0, 11);
        
        setMazorRoboticsCode(res);
        const addProcData = [...procedureInfoData.additionalProcedure];
        const mazorxIdx = addProcData.findIndex(
            (x) => x.description === 'MazorX Robot Used' && x.isSelected
        );
        if (mazorxIdx >= 0) {
            addProcData[mazorxIdx].mazorKitCode = res;
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    aditionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }

        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);
        const isValid11Char = /^[A-Za-z0-9!@#$%^&*()]+$/.test(res);
        const isValidLength =
            (res.length === 7 && isAlphanumericOnly) || 
            (res.length === 11 && isValid11Char);

        if (isValidLength) {
            dispatch(
                validateMazorCodeRequest({
                    mazorKitCode: encodeURIComponent(res),
                })
            );
        } else {
            dispatch({
                type: VALIDATE_MAZOR_CODE_RESPONSE,
                payload: null,
            });
        }
    };



    const mazorCodeValidatorOnBlur = (e) => {
        const res = e.target.value.replace(/[^A-Za-z0-9!@#$%^&*()]/g, '').slice(0, 11);
        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);
        
        const invalidMessage = t(
            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.mazorXUsed.invalidMsg'
        );
        
        const getValidationPayload = () => {
            if (res.length === 0) {
                return null;
            }
            
            if (res.length < 7 || (res.length > 7 && res.length < 11)) {
                return {
                    statusCode: 'failed',
                    statusDescription: invalidMessage,
                };
            }
            
            if (res.length === 7) {
                return isAlphanumericOnly
                    ? validateMazorCodeRes
                    : {
                          statusCode: 'failed',
                          statusDescription: invalidMessage,
                      };
            }
            
            if (res.length === 11) {
                return validateMazorCodeRes;
            }
            
            return null;
        };
        
        dispatch({
            type: VALIDATE_MAZOR_CODE_RESPONSE,
            payload: getValidationPayload(),
        });
    };

    const stealthCodeValidatorOnBlur = (e) => {
        dispatch({
            type: VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
            payload:
                e.target.value.length < 6
                    ? {
                        statusCode: 'failed',
                        statusDescription: stealthAxisCodeError,
                    }
                    : e.target.value.length === 6
                        ? 'Valid Code'
                        : null,
        });
    };

    const checkboxSelectionChangeHandler = (e, card, idx, val) => {
        let modifiedData = [];
        if (card === 'additionalProcedureData') {
            let temp = {};
            let energyProd = [...advanceEnergyProduct];
            if (energyProd[idx].description === val) {
                energyProd[idx].isSelected = !energyProd[idx].isSelected;
            }
            setAdvanceEnergyProduct(energyProd);
            energyProd.forEach((ob) => {
                temp[ob.description] = ob.isSelected;
            });

            if (temp) {
                let data = temp;
                dispatch({
                    type: SET_ADVANCE_ENERGY_DATA,
                    payload: data,
                });
                setAdvEnergyCode(!advEnergyCode);
            }

            let tempProcedureData = { ...procedureInfoData };
            let ind = tempProcedureData.additionalProcedure.findIndex(
                (it) =>
                    it.description ===
                    t(
                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.advancedEnergy'
                    )
            );
            let procAdditionalData = tempProcedureData.additionalProcedure;
            procAdditionalData[ind].advancedEnergyProduct = temp;

            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: procAdditionalData,
                })
            );

        } else if (card === 'physicianFinder') {
            modifiedData = getModifiedPhysicianFinderDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                therapies: modifiedData,
            }));
            const modifiedAdditionalProcedureData =
                getModifiedAdditionalProcedureData(
                    procedureInfoData,
                    val,
                    e.target.checked
                );
            if (modifiedAdditionalProcedureData) {
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: modifiedAdditionalProcedureData,
                }));
            }
        } else if (card === 'retractorsUsed') {
            if (
                (val === 'Other' && !e.target.checked) ||
                (val === 'None' && e.target.checked)
            ) {
                dispatch(setRetractorUsedOtherField(''));
            }
            modifiedData = getModifiedRetractorUsedOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    retractors: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                retractors: modifiedData,
            }));
        } else if (card === 'biologicsUsed') {
            modifiedData = getModifiedBiologicsUsedDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            const medtronicOrCompetitve = modifiedData.filter(
                (x) => x.isSelected && x.code === '02'
            );
            const isNoneChecked =
                modifiedData.filter((x) => x.isSelected && x.code === '01')
                    ?.length > 0;
            if (medtronicOrCompetitve.length > 0) {
                setshowBiologisDetails(true);
            } else {
                setshowBiologisDetails(false);
            }
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsUsed: modifiedData,
                biologicsDetail:
                    isNoneChecked || medtronicOrCompetitve.length === 0
                        ? procedureInfoData.biologicsDetail?.map((item) => ({
                            ...item,
                            isMedtronicSelected: null,
                            isCompetitiveSelected: null,
                        }))
                        : prevState.biologicsDetail,
            }));
        } else if (
            card === 'biologicsDetailMedtronic' ||
            card === 'biologicsDetailCompetitive'
        ) {
            modifiedData = [...procedureInfoData.biologicsDetail];
            modifiedData[idx][
                card === 'biologicsDetailMedtronic'
                    ? 'isMedtronicSelected'
                    : 'isCompetitiveSelected'
            ] = e.target.checked;
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsDetail: modifiedData,
            }));
        }
    };

    const handleInputChange = (name, value) => {
        let object = {
            [name]: value,
        };
        dispatch(setRetractorUsedOtherField(value));
    };

    const setShowUnsavedChangesPopup = (val) => {
        dispatch(setShowUnsavedReportUsageChangesPopUp(val));
    };

    const discardChangesBtnClickHandler = (dismountFlag) => {
        dispatch(setPediatricCheck(''));
        (cancelSurgeryData?.myCaseRef && cancelSurgeryData?.myCaseRef?.length > 0) && unlockOrderFunc({
            action: 'NoUsageToReport',
            myCaseRefId: cancelSurgeryData?.myCaseRef,
        });
        dispatch(
            setShowNoUsageToReportOrCancelPopup({
                showNoUsagePopup: false,
                showCancelPopup: false,
                surgeryData: {},
                viewProcedureScreen: false,
                cancelReason: null,
                showCaseCancelOrPostpone: false,
            })
        );
        if (!dismountFlag) {
            const fromScreen = localStorage.getItem('pageName');
            history.push(
                fromScreen === 'Orders'
                    ? getRoutePathWithParams('/orders')
                    : getRoutePathWithParams('/')
            );
        }
        dispatch(resetReportUsageStates());
        dispatch(resetNotes());
        dispatch(resetDropdown());
        setShowUnsavedChangesPopup(false);
        dispatch({ type: RESET_CANCEL_USAGE_STATES });
    };

    const submitBtnClickHandler = () => {
        if (
            cancelSurgeryData?.myCaseRef &&
            cancelReason &&
            usageDetails?.unidId &&
            Object.keys(
                generateUnidInfoRequestObject(storedUnidSurgeryData, {
                    ...cancelReason,
                    unidId: usageDetails?.unidId,
                })
            ).length > 0
        ) {
            dispatch(
                cancelUsageOrderRequest({
                    cancelReason: cancelReason.optionId,
                    myCaseRef: cancelSurgeryData.myCaseRef,
                    unidNonUse: generateUnidInfoRequestObject(
                        storedUnidSurgeryData,
                        { ...cancelReason, unidId: usageDetails?.unidId }
                    ),
                })
            );
        } else if (cancelSurgeryData?.myCaseRef && cancelReason) {
                let procedureObj = createProcedureDraftOrderObject(
                    procedureInfoData,
                    advanceEnergyProduct,
                    retractorUsedOtherFieldValue,
                    uivArray,
                    livArray,
                    totalLevelsNumber
                );

                // Set default value of procedureObj for mandatory fields if empty
                procedureObj = {
                    additionProcedure: {
                        isPowerease: procedureObj?.additionProcedure?.isPowerease
                            ? procedureObj.additionProcedure.isPowerease
                            : false,
                        isMazorXRoboticsUsed: procedureObj?.additionProcedure
                            ?.isMazorXRoboticsUsed
                            ? procedureObj.additionProcedure.isMazorXRoboticsUsed
                            : false,
                        isNavigaton: procedureObj?.additionProcedure?.isNavigaton
                            ? procedureObj.additionProcedure.isNavigaton
                            : false,
                        isAdvancedEnergy: procedureObj?.additionProcedure
                            ?.isAdvancedEnergy
                            ? procedureObj.additionProcedure.isAdvancedEnergy
                            : false,
                        ...procedureObj.additionProcedure,
                    },
                    physicianFinderEligibility:
                        procedureObj?.physicianFinderEligibility
                            ? procedureObj.physicianFinderEligibility
                            : '',
                    usedRetractors: procedureObj?.usedRetractors
                        ? procedureObj.usedRetractors
                        : ['0001'],
                    usedUIV: procedureObj?.usedUIV ? procedureObj.usedUIV : ['01'],
                    usedLIV: procedureObj?.usedLIV ? procedureObj.usedLIV : ['01'],
                    deformityCorrectionCode: procedureObj?.deformityCorrectionCode
                        ? procedureObj.deformityCorrectionCode
                        : '87',
                    biologicsUsed: procedureObj?.biologicsUsed
                        ? procedureObj.biologicsUsed
                        : ['01'],
                    ...procedureObj,
                };
                !procedureObj.physicianFinderEligibility && delete procedureObj.physicianFinderEligibility;

                // Build payload matching the create/update-usage submit contract.
                const cancelUsagePayload = {
                    cancelReason: cancelReason.optionId,
                    myCaseRef: cancelSurgeryData.myCaseRef,
                    procedure: procedureObj,
                };
                // Backend expects '' (not the 'Other Physician' sentinel) when
                // no real dropdown ID is available. See surgeryDetailsSaga.js.
                const resolvedPhysicianId =
                    selectedPhysicianData?.physicianId &&
                    selectedPhysicianData.physicianId !== OTHER_PHYSICIAN
                        ? selectedPhysicianData.physicianId
                        : usageDetails?.physicianId &&
                          usageDetails.physicianId !== OTHER_PHYSICIAN
                            ? usageDetails.physicianId
                            : '';
                cancelUsagePayload.physicianId = resolvedPhysicianId;
                if (physicianTextUsageVisibility === VISIBLE) {
                    cancelUsagePayload.physicianFieldText =
                        physicianTextBoxType === 'unknown'
                            ? ''
                            : physicianFieldText ||
                              selectedPhysicianData?.physicianDisplayName ||
                              cancelSurgeryData?.physicianName ||
                              usageDetails?.physicianName ||
                              '';
                    cancelUsagePayload.physicianTextBoxType = physicianTextBoxType;
                }
                if (usageDetails?.accountId) {
                    cancelUsagePayload.accountId = usageDetails.accountId;
                }
                if (usageDetails?.surgeryDate) {
                    cancelUsagePayload.surgeryDate = usageDetails.surgeryDate;
                }
                if (reportUsageObject?.procedureCode || usageDetails?.procedureCode) {
                    cancelUsagePayload.procedureCode =
                        reportUsageObject?.procedureCode || usageDetails.procedureCode;
                } 
                dispatch(cancelUsageOrderRequest(cancelUsagePayload));
            }
    };

    const cancelCompletionModalCloseHandler = () => {
        if (cancelUsageResponse) {
            if (isFromOrderDetailsModal) {
                dispatch(setOrderStatus({ orderStatus: '' }));
                dispatch(getOrderSummaryData());
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: cancelSurgeryData?.myCaseRef,
                        orderSummaryModal: true,
                    })
                );
            }
            discardChangesBtnClickHandler();
        }
    };
    const openUNIDLinks = () => {
        const { unidIdURL } = usageDetails;
        if (unidIdURL === 'EmptyUrl' || !unidIdURL) {
            setPdfNotAvailable(true);
        } else {
            const urls = unidIdURL.split('*#*').filter((url) => url);
            urls.forEach((url) => {
                window.open(url);
            });
        }
    };
    return (
        <div>
            {usageDetailsLoading ||
                procedureDataLoading ||
                cancelUsageInProgress ||
                loading ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner id="procedure-index-backdrop-loadingSpinner" animation="border" variant="primary" small />
                </Backdrop>
            ) : (
                <>
                    {kitCodeValidationInProgress && (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <Spinner
                                id="procedure-index-mazorValidation-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </Backdrop>
                    )}
                    <NoUsageProcedureHeader
                        isNoUsageToReport
                        cancelSurgeryData={noUsageOrderDetails}
                        selectedPhysicianData={selectedPhysicianData}
                        paddingBottom={
                            cancelReason?.optionId == 'UNID_NON_USE' && '10px'
                        }
                        cancelReason={cancelReason?.optionId}
                    />
                    <UsageContainer
                        isNoUsageToReport
                        mbPosition={'fixed'}
                        id="UsageContainer"
                    >
                        {window.innerWidth <= sizes.mobileDevice && (
                            <MultiViewComponent flexAlign={'flex-start'}>
                                {noUsageOrderDetails &&
                                    Object.keys(noUsageOrderDetails).length >
                                    0 && (
                                        <ReportUsageSubHeader
                                            usageDetails={noUsageOrderDetails}
                                            selectedPhysicianData={
                                                selectedPhysicianData
                                            }
                                            openUNIDLinks={openUNIDLinks}
                                        />
                                    )}
                            </MultiViewComponent>
                        )}
                        {!cancelUsageResponse && (
                            <>
                                {cancelReason?.optionId != 'UNID_NON_USE' && (
                                    <TitleComponent
                                        lineHeight={'0px !important'}
                                        paddingTop={'0px !important'}
                                    >
                                        {t(
                                            'orders.orderSummaryTabs.procedureData'
                                        )}
                                    </TitleComponent>
                                )}
                                {cancelReason?.optionId != 'UNID_NON_USE' &&
                                    procedureInfoData &&
                                    Object.keys(procedureInfoData).length >
                                    0 && (
                                        <ProcedureViewContainer
                                            isNoUsageToReport
                                            procedureInfoData={
                                                procedureInfoData
                                            }
                                            setProcedureInfoData={
                                                setProcedureInfoData
                                            }
                                            advancedEnergyCheck={
                                                advancedEnergyCheck
                                            }
                                            advanceEnergyProduct={
                                                advanceEnergyProduct
                                            }
                                            radioButtonChangeHandler={
                                                radioButtonChangeHandler
                                            }
                                            mazorxChecked={mazorxChecked}
                                            mazorRoboticsCode={
                                                mazorRoboticsCode
                                            }
                                            mazorCodeValidator={
                                                mazorCodeValidator
                                            }
                                            mazorCodeValidatorOnBlur={
                                                mazorCodeValidatorOnBlur
                                            }
                                            validateMazorCodeRes={
                                                validateMazorCodeRes
                                            }
                                            retractorUsedOtherFieldValue={
                                                retractorUsedOtherFieldValue
                                            }
                                            textAreaCharLimit={
                                                textAreaCharLimit
                                            }
                                            charCountLimit={charCountLimit}
                                            checkboxSelectionChangeHandler={
                                                checkboxSelectionChangeHandler
                                            }
                                            handleInputChange={
                                                handleInputChange
                                            }
                                            showBiologisDetails={
                                                showBiologisDetails
                                            }
                                            selectedPhysicianData={
                                                selectedPhysicianData
                                            }
                                            setSelectedPhysicianData={
                                                setSelectedPhysicianData
                                            }
                                            setPhysicianInputValue={
                                                setPhysicianInputValue
                                            }
                                            physicianInputValue={
                                                physicianInputValue
                                            }
                                            setMazorCaseCoverageInputValue={
                                                setMazorCaseCoverageInputValue
                                            }
                                            mazorCaseCoverageInputValue={
                                                mazorCaseCoverageInputValue
                                            }
                                            setSelectedMazorCaseCoverage={
                                                setSelectedMazorCaseCoverage
                                            }
                                            selectedMazorCaseCoverage={
                                                selectedMazorCaseCoverage
                                            }
                                            showProcedureDropdown={
                                                showProcedureDropdown
                                            }
                                            procedureValue={{
                                                procedureCode:
                                                    usageDetails?.procedureCode,
                                                procedureDescription:
                                                    usageDetails?.procedureDescription,
                                            }}
                                            proceduresList={proceduresList}
                                            cancelReason={cancelReason}
                                            noUsageToReportMycaseRefId={
                                                cancelSurgeryData?.myCaseRef
                                            }
                                            dropDownValue={
                                                downArrow
                                                    ? temporaryProcedureDropdownValue
                                                    : procedureDropdownValue
                                            }
                                            setDropDownValue={
                                                setProcedureDropdownValueHandler
                                            }
                                            countryCode={userCountryCode}
                                            isDraft={false}
                                            procedureDataPhysicianVisibility={
                                                procedureDataPhysicianVisibility
                                            }
                                            procedureMandatoryRule={
                                                procedureTypeUsageMandatoryRule ===
                                                MANDATORY
                                            }
                                            isDisabledPediatric={
                                                isDisabledPediatric
                                            }
                                            setPediatricCheck={
                                                setPediatricCheck
                                            }
                                            isPediatricSurgery={
                                                isPediatricSurgery
                                            }
                                            isFromProcedure={true}
                                            setStealthAxisChecked={
                                                setStealthAxisChecked
                                            }
                                            pediatricSurgeryVisibility={
                                                pediatricSurgeryVisibility
                                            }
                                            pediatricMandatoryRule={
                                                pediatricMandatoryRule
                                            }
                                            pediatricValue={pediatricCheck}
                                            stealthAxisChecked={
                                                stealthAxisChecked
                                            }
                                            stealthAxisCode={stealthAxisCode}
                                            setStealthAxisCode={
                                                setStealthAxisCode
                                            }
                                            stealthAxisAutoPilot={
                                                stealthAxisAutoPilot
                                            }
                                            setStealthAxisAutoPilot={
                                                setStealthAxisAutoPilot
                                            }
                                            stealthAxisLiveAlign={
                                                stealthAxisLiveAlign
                                            }
                                            setStealthAxisLiveAlign={
                                                setStealthAxisLiveAlign
                                            }
                                            setStealthAxisCaseCoverageInputValue={
                                                setStealthAxisCaseCoverageInputValue
                                            }
                                            stealthAxisCaseCoverageInputValue={
                                                stealthAxisCaseCoverageInputValue
                                            }
                                            setSelectedStealthAxisCaseCoverage={
                                                setSelectedStealthAxisCaseCoverage
                                            }
                                            selectedStealthAxisCaseCoverage={
                                                selectedStealthAxisCaseCoverage
                                            }
                                            setStealthAxisCodeError={
                                                setStealthAxisCodeError
                                            }
                                            stealthAxisCodeError={
                                                stealthAxisCodeError
                                            }
                                            stealthCodeValidatorOnBlur={
                                                stealthCodeValidatorOnBlur
                                            }
                                             reportUsageStealthAutoPilotVisibility={reportUsageStealthAutoPilotVisibility}
                                             reportUsageStealthLiveAlignVisibility={reportUsageStealthLiveAlignVisibility}
                                             physicianFieldText={physicianFieldText}
                                             setPhysicianFieldText={setPhysicianFieldText}
                                             physicianTextBoxType={physicianTextBoxType}
                                             setPhysicianTextBoxType={setPhysicianTextBoxType}
                                        />
                                    )}
                                {cancelReason?.optionId == 'UNID_NON_USE' && (
                                    <UnidSurgeryInfo
                                        unidSurgeryInfo={unidSurgeryInfo}
                                        setUnidSurgeryInfo={setUnidSurgeryInfo}
                                        storedUnidSurgeryData={
                                            storedUnidSurgeryData
                                        }
                                    />
                                )}
                            </>
                        )}
                        {showUnsavedChangesPopup && (
                            <CancelAlertPopup
                                popupTitle={t(
                                    'consignmentBilling.common.notifications.popUp1'
                                )}
                                alertMessage={t(
                                    'consignmentBilling.common.notifications.text1'
                                )}
                                btn2Label={t(
                                    'consignmentBilling.common.notifications.continueEditing'
                                )}
                                btn1Label={t(
                                    'consignmentBilling.common.notifications.discardChangesAndExit'
                                )}
                                btn2ClickHandler={() =>
                                    setShowUnsavedChangesPopup(false)
                                }
                                btn1ClickHandler={discardChangesBtnClickHandler}
                            />
                        )}
                        {cancelUsageResponse && (
                            <SubmissionViewContainer
                                isUsagedSubmittedSuccessfully={
                                    cancelUsageResponse &&
                                    cancelUsageResponse.statusCode === '200'
                                }
                                noUsageMyCaseRefId={
                                    cancelUsageResponse?.myCaseRef
                                }
                                usageOrderSubmission={cancelUsageResponse}
                                noUsageSubmittedMessage={
                                    cancelUsageResponse?.statusMessage ||
                                    cancelUsageResponse?.statusDescription
                                }
                                isNoUsageSubmitPage={true}
                                onCTAButtonClick={
                                    cancelCompletionModalCloseHandler
                                }
                                cancelSurgeryData={cancelSurgeryData}
                                cancelReason={cancelReason}
                            />
                        )}
                        {pdfNotAvailable && (
                            <UnidPlanPdfNotAvailable
                                onClose={() => setPdfNotAvailable(false)}
                            />
                        )}
                    </UsageContainer>
                    {!cancelUsageResponse && (
                        <ReportUsageFooter
                            footerButtonStatuses={footerButtonStatuses}
                            cancelBtnClickHandler={() =>
                                setShowUnsavedChangesPopup(true)
                            }
                            submitBtnClickHandler={submitBtnClickHandler}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default Procedure;
